var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item-group',[_c('a',{attrs:{"href":_vm.decFileURL,"download":_vm.unzippedDecFileName}},[_c('v-icon',[_vm._v("mdi-paperclip")]),_vm._v(_vm._s(_vm.unzippedDecFileName)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }